const DemoTradingAccountContentOne = () => {
  const accountTypes = [
    {
      title: "Real Market Conditions, Virtual Money",
      description:
        "Practice in a true market environment with no financial risk — the perfect setup for mastering the fundamentals.",
      image:
        process.env.PUBLIC_URL +
        "/images/trading/demo_trading_account/demo_acc_1.png",
    },

    {
      title: "Unlimited Testing & Strategy Building",
      description:
        "Try new methods, experiment with indicators, or backtest ideas without pressure or consequences.",
      image:
        process.env.PUBLIC_URL +
        "/images/trading/demo_trading_account/demo_acc_2.png",
    },
    {
      title: "Full Access to All Instruments",
      description:
        "Trade FX, commodities, crypto, indices, and more, the same assets available on real accounts.",
      image:
        process.env.PUBLIC_URL +
        "/images/trading/demo_trading_account/demo_acc_3.png",
    },
    {
      title: "Seamless Progression to Live Trading",
      description:
        "The moment you’re ready, switch to a live account instantly with your preferred tier.",
      image:
        process.env.PUBLIC_URL +
        "/images/trading/demo_trading_account/demo_acc_4.png",
    },
  ];

  return (
    <div className="quality-section-trading">
      <div className="quality-header-trading">
        <h1>Train Like a Trader. Risk Like a Beginner.</h1>
        <p>
          Explore powerful tools designed to help you learn faster, trade
          smarter, and build confidence, all in a zero-risk environment.
        </p>
      </div>

      <div className="image-cards-container">
        {accountTypes.map((account, index) => (
          <div
            key={index}
            className="image-trading-card"
            style={{ backgroundImage: `url(${account.image})` }}
          >
            <div className="card-header">
              <div className="title-row">
                <h2 className="card-title">{account.title}</h2>
              </div>
              <p className="card-description">{account.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemoTradingAccountContentOne;
